import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { WorkflowComponentProps } from '../../../../Workflow/Workflow.meta';

interface Props {
  clientId: string;
  workflowProps?: WorkflowComponentProps;
}

export const BusinessEmpty = ({ clientId, workflowProps }: Props) => {
  const handleClick = () => {
    if (workflowProps) {
      const params = {
        workflowId: workflowProps.workflowId,
        stepId: 5,
        pageId: 'otherassets',
        clientId,
        pivotId: 0,
      };

      return ADV.util.Router.go2('Workflow', params);
    }
    return ADV.util.Router.go2('Profile', { clientId, pivotId: 0, pageId: 'otherassets' });
  };

  return (
    <Box display="flex" alignItems="center" py="4">
      <Button onClick={handleClick} variant="link" mr="2">
        Add a Business Asset
      </Button>

      <Text fontWeight={500} color="neutral.500">
        to create a business income.
      </Text>
    </Box>
  );
};
